export const LOGOS = {
  logoBlack:
    'https://res.cloudinary.com/socialnet-website-media/image/upload/v1693305241/socialnetlogo_black_4f90db35d3.webp',
  logoWhite:
    'https://res.cloudinary.com/socialnet-website-media/image/upload/v1705904069/logo_19cab86f39.webp',
  logoTextBlack:
    'https://res.cloudinary.com/socialnet-website-media/image/upload/v1693305241/socialnetlogo_text_black_a77e39612f.webp',
  logoTextWhite:
    'https://res.cloudinary.com/socialnet-website-media/image/upload/v1706197785/logo_bijeli_01_a69410e774.webp',
  logotip: 'https://res.cloudinary.com/socialnet-website-media/image/upload/v1706198297/logo_bijeli_02_0cc02d4df8.webp',
  logoTextMobile: 'https://res.cloudinary.com/socialnet-website-media/image/upload/v1706198300/logo_bijeli_03_b0be56cfb3.webp'
};

export const HEADER_MENU = [
  {
    text: 'Home',
    path: '/',
  },
  {
    text: 'About',
    path: '/about-us',
  },
  {
    text: 'Industries',
    path: '/industries',
  },
  {
    text: 'Services',
    path: '/services',
  },
  {
    text: 'Insights',
    path: '/insights',
  },
];

export const FOOTER_MENU = [
  {
    text: 'Contact us',
    path: '/contact-us',
  },
  {
    text: 'Terms and Conditions',
    path: '/terms-and-conditions',
  },
  {
    text: 'Privacy Policy',
    path: '/privacy-policy',
  },
  {
    text: 'Impressum BH',
    path: '/impressum',
  },
];

export const CLOUDINARY = 'https://res.cloudinary.com/socialnet-website-media';

export const toastConfig = {
  position: 'bottom-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'light',
};

export const FETCH_SCHEMA_BODY = {
  operationName: 'IntrospectionQuery',
  query: `query IntrospectionQuery {
    __schema {
      queryType {
        name
      }
      mutationType {
        name
      }
      subscriptionType {
        name
      }
      types {
        ...FullType
      }
      directives {
        name
        description
        locations
        args {
          ...InputValue
        }
      }
    }
  }
  
  fragment FullType on __Type {
    kind
    name
    description
    fields(includeDeprecated: true) {
      name
      description
      args {
        ...InputValue
      }
      type {
        ...TypeRef
      }
      isDeprecated
      deprecationReason
    }
    inputFields {
      ...InputValue
    }
    interfaces {
      ...TypeRef
    }
    enumValues(includeDeprecated: true) {
      name
      description
      isDeprecated
      deprecationReason
    }
    possibleTypes {
      ...TypeRef
    }
  }
  
  fragment InputValue on __InputValue {
    name
    description
    type {
      ...TypeRef
    }
    defaultValue
  }
  
  fragment TypeRef on __Type {
    kind
    name
    ofType {
      kind
      name
      ofType {
        kind
        name
        ofType {
          kind
          name
          ofType {
            kind
            name
            ofType {
              kind
              name
              ofType {
                kind
                name
                ofType {
                  kind
                  name
                }
              }
            }
          }
        }
      }
    }
  }
  `,
  variables: {},
};
